/**
 * AI icon component for IA Corner displays.
 * Renders an SVG icon representing AI-generated content with customizable size and styling.
 */

import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

/**
 * Renders an AI icon SVG for IA Corner indicators.
 * Displays a stylized AI symbol with customizable dimensions.
 *
 * @param {Props} props - Button props including height, width, padding, margin, and scale
 * @returns {JSX.Element} AI icon SVG element
 */
export default function AIIcon({
  height,
  width,
  padding,
  margin,
  scale = 1,
}: Props) {
  return (
    <svg
      id='AIIcon'
      fill='none'
      height={`${height || 44 * Screen.widthRatio * scale}`}
      width={`${width || 53 * Screen.widthRatio * scale}`}
      style={{ padding, margin }}
      viewBox={'0 0 60 53'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M37.6202 27.2985C27.2382 23.8906 22.3074 15.6237 20.5735 10.0744C20.3887 9.48294 19.3588 9.44714 19.1486 10.03C15.3848 20.4661 7.4981 25.542 2.33554 27.365C1.7639 27.5668 1.74767 28.5525 2.318 28.758C12.5613 32.4499 17.4191 40.0671 19.2019 45.3513C19.4065 45.9575 20.602 45.9753 20.8121 45.371C24.2111 35.5926 32.2073 30.6242 37.6264 28.7376C38.2118 28.5338 38.2091 27.4918 37.6202 27.2985Z'
        fill='white'
      />
      <path
        d='M51.432 11.4985C46.4689 9.50471 43.7953 5.60438 42.5901 2.55689C42.3622 1.9807 41.2308 1.94839 40.9882 2.5185C38.8476 7.54931 35.0767 10.2995 32.2122 11.5497C31.6564 11.7923 31.6431 12.8615 32.2022 13.0962C37.0368 15.1253 39.6889 18.6492 40.9544 21.5123C41.2129 22.0974 42.5778 22.112 42.8346 21.5261C44.8278 16.9779 48.523 14.3753 51.4441 13.1219C52.0138 12.8775 52.0072 11.7296 51.432 11.4985Z'
        fill='white'
      />
      <path
        d='M47.4742 42.3936C44.148 40.8711 42.2146 38.2255 41.2246 35.9907C40.9728 35.4224 39.7696 35.393 39.5074 35.9566C37.9056 39.3991 35.3542 41.413 33.2704 42.4413C32.7285 42.7087 32.7179 43.8197 33.2655 44.0751C36.4689 45.5692 38.3834 47.9219 39.4249 49.9886C39.7136 50.5614 41.1967 50.5726 41.4822 49.9982C42.9825 46.9802 45.4174 45.1272 47.4895 44.1216C48.0453 43.8518 48.036 42.6508 47.4742 42.3936Z'
        fill='white'
      />
    </svg>
  );
}
